import { Container } from "@mui/material";
import React from "react";
import {
  Box,

  Typography,
  Grid,

  Button,
  TextField,
  Checkbox,
} from "@mui/material";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import { Link } from "react-router-dom";
import { useCart } from "react-use-cart";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
const Checkout = () => {
  const { items, cartTotal, emptyCart } = useCart();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [user1, setuser1] = useState({});


  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("MyUser"));
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  
  

  const handeleChange = (e) => {
    const { name, value } = e.target;
    setuser1({
      ...user1,
      [name]: value,
    });
  };

  const placeorder = () => {
    const orderData = {
      name: user1.name,
      message: user1.message,
      number: user1.number,
      address: user1.address,
      cartItems: items.map((item) => ({
        img: item.img,
        name: item.name,
        quantity: item.quantity,
        price: item.quantity * item.price,
        Size:item.size,
        color:item.color
      })),
    };

    axios.post("http://localhost:9002/checkout", orderData);
  };
  const updaterUser = (user) => {
    localStorage.setItem("MyUser", JSON.stringify(user));
    setUser(user);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (user1) {
      if (user1.address) {
        if (user1.number.length>=10) {
          enqueueSnackbar("Your Order was placed ", { variant: "success" });
          placeorder();
          emptyCart();
          navigate("/")
        } else {
          enqueueSnackbar("Please type your number to place an order!", { variant: "error" });
        }
      } else {
        enqueueSnackbar("Please type your address to place an order!", { variant: "error" });
      }
    } else {
      enqueueSnackbar("Please fill the form completely.", { variant: "error" });
    }
  };
  return (
    <React.Fragment>
      {user && user._id ? (
        <Container updaterUser={updaterUser}>
          <Grid container spacing={10}>
            <Grid item lg={4} md={6} xs={12}>
              <Typography
                sx={{ mt: 15, fontSize: "1.5rem", fontWeight: "bold" }}
              >
                Order Details 📰 :
              </Typography>
              <TextField
                name="name"
                value={user.name}
                onChange={handeleChange}
                id="outlined-basic"
                label="Name"
                variant="outlined"
                sx={{ mt: 2,  }}

                fullWidth
              />
              <Typography sx={{ display: "flex" }}>
                {" "}
                <TextField
                  name="address"
                  value={user.address}
                  onChange={handeleChange}
                  sx={{
                    mt: 4,
                    mb: 2,
                    width: { xs: "19ch", md: "22ch", lg: "25ch" },
                  }}
                  id="outlined-basic"
                  label=" Address"
                  variant="outlined"
                />
                <TextField
                  name="number"
                  value={user.number}
                  onChange={handeleChange}
                  sx={{
                    mt: 4,
                    ml: 2,
                    mb: 2,
                    width: { xs: "19ch", md: "22ch", lg: "25ch" },
                  }}
                  id="outlined-basic"
                  label="Mobile Number"
                  variant="outlined"
                />
              </Typography>
              <TextField
                name="message"
                value={user.message}
                onChange={handeleChange}
                id="outlined-basic"
                label="Message"
                variant="outlined"
                sx={{ mt: 2, }}
                rows={4}
                multiline
                fullWidth
              />

              <Typography
                sx={{ mt: 5, fontSize: "1.5rem", fontWeight: "bold" }}
              >
                {" "}
                Payment Method:
              </Typography>
              <Typography><span style={{fontWeight:"bold"}}>Esewa, Khalti:</span>  98604280222</Typography>
              <Typography><span style={{fontWeight:"bold"}}>Nic Asia Bank:</span> 1735752228056001</Typography>
              <Box sx={{ display: "flex", mt: 4 }}>
             
                <Box
                  component="img"
                  src="esewa.png"
                  maxWidth="150px"
                  sx={{ cursor: "pointer" }}
                />
           
                <Box
                  component="img"
                  src="khalti.png"
                  maxWidth="150px"
                  sx={{ cursor: "pointer", ml: 2 }}
                />
              </Box>
              

              <Box
                component="img"
                src="ips.png"
                maxWidth="150px"
                sx={{ cursor: "pointer", mt: 2 }}
              />
              <Button
            onClick={handleSubmit}
            sx={{
              mt: 5,
              fontSize: "1.1rem",
              cursor: "pointer",
           
              bgcolor: "green",
              color: "white",
              textTransform: "none",
              padding: "5px 50px 5px 50px",
              ":hover": {
                cursor: "pointer",
                transform: "scale(1.05)",
                bgcolor: "green",
                color: "white",
                transition: "0.3s",
                textTransform: "none",
              },
            }}
          >
            Place Order
          </Button>
            </Grid>
            <Grid item lg={8} md={6} xs={12}>
              <Box
                boxShadow={24}
                sx={{ mt: { lg: 15, xs: 2 }, paddingBottom: 2 }}
              >
                <Typography
                  sx={{
                    paddingLeft: "30px",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    mb: 4,
                  }}
                >
                  Cart Summary{" "}
                  <AddShoppingCartIcon
                    sx={{ marginTop: "auto", paddingTop: 5 }}
                  />{" "}
                  <Link to="/wintercollection">
                    {" "}
                    <span style={{ fontSize: "1.2rem" }}>(Edit)</span>
                  </Link>
                </Typography>
                {items.map((item, index) => {
                  return (
                    <Box
                      display="flex"
                      minHeight={95}
                      alignItems="center"
                      key={index}
                      sx={{
                        borderBottom: 1,
                        borderColor: "divider",
                        ml: 3,
                        maxWidth: { lg: 900, md: 450, xs: 350 },
                      }}
                    >
                      <Box component="img" src={item.image} maxWidth={80} />
                      <Typography sx={{ marginLeft: "auto" }}>
                        {item.name}
                      </Typography>
                      <Typography sx={{ marginLeft: "auto" }}>
                       Size: {item.size}
                      </Typography>
                      <Typography sx={{ marginLeft: "auto" }}>
                        {item.color}
                      </Typography>
                      <Typography sx={{ marginLeft: "auto" }}>
                        {item.quantity} X Rs {item.price}
                      </Typography>
                      <Typography sx={{ marginLeft: "auto",mr:2 }}>
                        RS. {item.price * item.quantity}
                      </Typography>
                    </Box>
                  );
                })}{" "}
                <Typography
                  sx={{
                    textAlign: "center",
                    mt: 2,
                    paddingBottom: 1,
                    fontSize: "1.2rem",
                  }}
                >
                  Delivery Charge(🚲): {cartTotal / 100 + 50}
                </Typography>
                <Typography
                  sx={{
                    textAlign: "center",

                    paddingBottom: 2,
                    fontSize: "1.2rem",
                  }}
                >
                  Sub Total:Rs {cartTotal / 100 + 50 + cartTotal}
                </Typography>
              </Box>
            </Grid>
           
          </Grid>
          
        </Container>
      ) : (
        <Typography sx={{ mt: 20, textAlign: "center", fontSize: "1.3rem" }}>
          Please Login First <Link to="/login"> Click here</Link>{" "}
        </Typography>
      )}
    </React.Fragment>
  );
};

export default Checkout;
